import React, { ReactNode, RefObject } from 'react';

import { RowTabStopContext } from 'flow/components/ui-components/row-tab-stop';
import { RowStore, useStoreHoldsRow } from './row-index-store';
import useReportControlInTabOrder from './useReportControlInTabOrder';

interface Props {
    rowRef: RefObject<HTMLElement>;
    store: RowStore<string>;
    /** The row's key in the store, from uniqueRowKeys. */
    tabStopKey: string;
    children: ReactNode;
}

// When the Tab stop moves, only this provider and the controls that read it
// re-render; the row's other content keeps its elements.
const RowTabStop = ({ rowRef, store, tabStopKey, children }: Props) => {
    const rowIsTabStop = useStoreHoldsRow(store, tabStopKey);
    useReportControlInTabOrder(rowRef, rowIsTabStop);

    return (
        <RowTabStopContext.Provider value={rowIsTabStop}>
            {children}
        </RowTabStopContext.Provider>
    );
};

export const NoRowTabStop = ({
    rowRef,
    children,
}: Pick<Props, 'rowRef' | 'children'>) => {
    useReportControlInTabOrder(rowRef, false);

    return (
        <RowTabStopContext.Provider value={false}>
            {children}
        </RowTabStopContext.Provider>
    );
};

export default RowTabStop;
